import React, { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import { ModernCard, ModernCheckbox } from './ModernComponents';

const StepStrategies = ({
  selectedStrategies,
  setSelectedStrategies,
  yearsToSimulate,
  setYearsToSimulate,
  toggleSelection,
}) => {
  const { t } = useTranslation();

  const strategies = useMemo(
    () => [
      { id: 'HISTORY', name: t('simulation.common.historyOptimization') },
      { id: 'MAX_GM', name: t('simulation.common.freeOptimization') },
    ],
    [t],
  );
  useState(() => {
    if (selectedStrategies.length < 0) {
      setSelectedStrategies(['MAX_GM']);
    }
  }, []);
  return (
    <div className="space-y-6">
      <ModernCard title={t('simulation.step.strategies.title')} icon={TrackChangesIcon}>
        <h3>{t('simulation.step.strategies.optimizationTitle')}</h3>

        <div className="space-y-2">
          {strategies.map((strategy) => (
            <ModernCheckbox
              key={strategy.id}
              label={strategy.name}
              checked={selectedStrategies.includes(strategy.id)}
              onChange={() =>
                toggleSelection(strategy.id, selectedStrategies, setSelectedStrategies)
              }
            />
          ))}
        </div>

        <div className="warningNote">
          <p>{t('simulation.step.strategies.warning')}</p>
        </div>

        <div className="yearInput">
          <h3>{t('simulation.step.strategies.yearsTitle')}</h3>
          <input
            type="number"
            min="3"
            max="7"
            value={yearsToSimulate}
            onChange={(e) => setYearsToSimulate(parseInt(e.target.value))}
          />

          <div className="inputInfo">
            <p>{t('simulation.step.strategies.yearsInfo', { min: 3, max: 7 })}</p>
          </div>
        </div>
      </ModernCard>
    </div>
  );
};

export default StepStrategies;
